import React, { Fragment, useState, useEffect } from "react";
import { redeemPointsForGiftcard } from "../../../helpers/helpers";
import {
  fetchCustomer,
  fetchCustomerGiftcards,
} from "../../../actions/customerActions";
import { connect } from "react-redux";

const RedeemPointsGiftcardItem = ({
  imgUrl,
  title,
  desc,
  isButton = false,
  disabled = true,
  buttonText = "Redeem",
  appStateData,
  customerData,
  merchantData,
  fetchCustomerGiftcards,
}) => {
  let { shopDomain, customerId } = appStateData;
  let { customer } = customerData;
  let { merchant, currencySymbol } = merchantData;
  const [isSecondPage, setIsSecondPage] = useState(false);
  const [pointsValue, setPointsValue] = useState(0);

  useEffect(() => {
    setPointsValue(merchant?.giftCardRedeemPoints ?? 0);
  }, [merchant?.giftCardRedeemPoints]);

  return (
    <div className="waysToRedeem-item-container">
      {!isSecondPage ? (
        <Fragment>
          <div className="waysToRedeem-item-image-container">
            <img src={imgUrl} alt="icon" />
          </div>
          <div className="waysToRedeem-item-text-container">
            <p className="waysToRedeem-item-text">{title}</p>
          </div>
          <div className="waysToRedeem-item-details-container">
            <span className="waysToRedeem-item-details">{desc}</span>

            <button
              style={{
                visibility: !isButton ? "hidden" : "visible",
              }}
              disabled={disabled}
              onClick={() => setIsSecondPage((prev) => !prev)}
              className="waysToRedeem-item-button"
            >
              {buttonText}
            </button>
          </div>
        </Fragment>
      ) : (
        <div className="redeemPointsGiftacrdItem-detail-page-wrapper">
          {customer && customer?.points > 0 && (
            <Fragment>
              <h3 className="redeemPointsGiftacrdItem-input-text">
                {merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType
                      ?.redeemGiftcard ?? "Gift Card"
                  : "Gift Card"}
              </h3>
              <div className="redeemPointsGiftacrdItem-input-wrapper">
                <input
                  className="range-slider"
                  type="range"
                  step={merchant?.giftCardRedeemPoints}
                  min={merchant?.giftCardRedeemPoints}
                  max={customer?.points}
                  value={pointsValue}
                  onChange={(e) => setPointsValue(e.target.value)}
                />
              </div>

              <div className="redeemPointsGiftacrdItem-details-text">
                {customer?.points > 0
                  ? `${pointsValue} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : "Points"
                    } = ${currencySymbol}${
                      pointsValue / merchant?.giftCardRedeemPoints
                    }`
                  : "You don't have any points"}
              </div>

              <div className="redeemPointsGiftacrdItem-redeem-btn-container">
                <button
                  className="redeemPointsGiftacrdItem-redeem-btn"
                  onClick={async () => {
                    if (customer?.points >= pointsValue && pointsValue > 0) {
                      let giftcardAmt =
                        pointsValue / merchant?.giftCardRedeemPoints;
                      let { data } = await redeemPointsForGiftcard(
                        shopDomain,
                        customerId,
                        giftcardAmt
                      );

                      await fetchCustomer(customerId, shopDomain);
                      await fetchCustomerGiftcards(customerId, shopDomain);
                      setIsSecondPage((prev) => !prev);
                      window.scrollTo({
                        top: window.innerWidth < 768 ? 500 : 200,
                        behavior: "smooth",
                      });
                    }
                  }}
                >
                  {buttonText}
                </button>
              </div>
            </Fragment>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: (customerId, shopDomain) =>
    dispatch(fetchCustomer(customerId, shopDomain)),
  fetchCustomerGiftcards: (customerId, shopDomain) =>
    dispatch(fetchCustomerGiftcards(customerId, shopDomain)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedeemPointsGiftcardItem);
